import type { AppRouteRecordRaw, AppRouteModule } from '@/router/types'
// import { PAGE_NOT_FOUND_ROUTE } from '@/router/routes/basic'
// import { mainOutRoutes } from './mainOut'
import { PageEnum } from '@/enums/pageEnum'
import { t } from '@/hooks/web/useI18n'
import { LAYOUT } from '../constant'
import ICCARD_ROUTES from './modules/iccard'

// import.meta.glob() 直接引入所有的模块 Vite 独有的功能
const modules = import.meta.glob('./modules/**/*.ts', { eager: true })
const routeModuleList: AppRouteModule[] = []

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
  const mod = (modules as Recordable)[key].default || {}
  const modList = Array.isArray(mod) ? [...mod] : [mod]
  routeModuleList.push(...modList)
})

// 根路由
export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_LOGIN,
  meta: {
    title: 'Root'
  }
}

export const PermissionRoute: AppRouteRecordRaw = {
  path: '/permission',
  name: 'Permission',
  meta: {
    title: 'Permission'
  },
  component: () => import('@/views/sys/permission/index.vue')
}

// 登录路由
export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/index.vue'),
  meta: {
    title: t('routes.basic.login')
  }
}

export const AuthRoute: AppRouteRecordRaw = {
  path: '/auth',
  name: 'Auth',
  component: () => import('@/views/auth/index.vue'),
  meta: {
    title: t('routes.basic.auth')
  }
}

// Basic routing without permission
// NOTE: 根据具体 ui 需要路由进行变化，而且路由的权限问题还没确定下来
export const basicRoutes = [RootRoute, PermissionRoute, LoginRoute, AuthRoute, ...routeModuleList]
